<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="cointype" label="币种"> </el-table-column>
      <el-table-column prop="amount" label="锁仓金额"> </el-table-column>
      <el-table-column prop="annualrate" label="利率"> </el-table-column>
      <el-table-column prop="day" label="锁仓天数"> </el-table-column>
      <el-table-column prop="defaultAmount" label="预计违约金额">
      </el-table-column>
      <el-table-column prop="defaultRate" label="违约费率"> </el-table-column>
      <el-table-column prop="interest" label="利息奖励"> </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="STATUS_TYPE[scope.row.status].type">{{
            STATUS_TYPE[scope.row.status].content
          }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import { STATUS_TYPE } from '../../constants';

export default {
  name: 'pledgeRecord',
  data() {
    return {
      STATUS_TYPE
    };
  },
  computed: {
    ...mapState('pledgeRecord', ['totalCount', 'pagination', 'rata', 'records'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('pledgeRecord', ['getRecords']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
